import { fileUrl } from "./content";

const fit = (s, base, min) => Math.max(min, base - Math.max(0, (s || "").length - 60) / 40);

function Details({ a, color = "rgba(255,255,255,0.8)" }) {
  const rows = [a.date, a.time, a.location, a.contact].filter(Boolean);
  if (!rows.length) return null;
  return (
    <div style={{ fontSize: "3.1cqh", color, marginTop: "3cqh", display: "flex", flexWrap: "wrap", gap: "1.2cqh 4cqw" }}>
      {a.date && <span>{a.date}</span>}{a.time && <span>{a.time}</span>}{a.location && <span>{a.location}</span>}{a.contact && <span>{a.contact}</span>}
    </div>
  );
}

export default function AnnouncementSlide({ a }) {
  const img = a.image_path ? fileUrl(a.image_path) : null;
  const title = { fontSize: `${fit(a.title, 9, 5)}cqh`, lineHeight: 1.08, fontWeight: 700, fontFamily: "'Playfair Display', Georgia, serif" };
  const body = { fontSize: `${fit(a.body, 4.4, 2.8)}cqh`, lineHeight: 1.4, marginTop: "2.5cqh", whiteSpace: "pre-line", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 6, WebkitBoxOrient: "vertical" };
  const tag = <div style={{ fontSize: "2.4cqh", letterSpacing: "0.3em", textTransform: "uppercase", color: "#D4AF37", marginBottom: "2cqh" }}>{a.category}</div>;
  const wrap = "absolute inset-0 flex flex-col justify-center";
  if (a.template === "flyer" && img) {
    return (
      <div className="absolute inset-0" style={{ background: "#000" }} data-testid="ann-slide">
        <img src={img} alt="" className="absolute inset-0 w-full h-full object-contain" />
      </div>
    );
  }
  if (a.template === "split") {
    return (
      <div className="absolute inset-0 grid grid-cols-2" style={{ background: a.color, color: "#fff" }} data-testid="ann-slide">
        <div className="relative overflow-hidden" style={{ background: "#000" }}>{img && <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" />}</div>
        <div className="flex flex-col justify-center" style={{ padding: "6cqh 5cqw" }}>{tag}<div style={title}>{a.title}</div><div style={body}>{a.body}</div><Details a={a} /></div>
      </div>
    );
  }
  if (a.template === "bold") {
    return (
      <div className={wrap} style={{ background: a.color, color: "#fff", padding: "8cqh 7cqw", borderLeft: "2.4cqw solid #D4AF37" }} data-testid="ann-slide">
        {img && <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: 0.22 }} />}
        <div className="relative">{tag}<div style={{ ...title, fontSize: `${fit(a.title, 11, 6)}cqh`, textTransform: "uppercase" }}>{a.title}</div><div style={body}>{a.body}</div><Details a={a} /></div>
      </div>
    );
  }
  if (a.template === "minimal") {
    return (
      <div className={`${wrap} items-center text-center`} style={{ background: "#0A0A0A", color: "#F5F1E6", padding: "8cqh 10cqw" }} data-testid="ann-slide">
        {tag}<div style={title}>{a.title}</div><div style={{ width: "8cqw", height: "0.4cqh", background: "#D4AF37", margin: "3cqh auto 0" }} /><div style={body}>{a.body}</div><Details a={a} color="#D4AF37" />
      </div>
    );
  }
  return (
    <div className={`${wrap} items-center text-center`} style={{ background: a.color, color: "#fff", padding: "8cqh 9cqw" }} data-testid="ann-slide">
      {img && <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: 0.35 }} />}
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.55))" }} />
      <div className="relative flex flex-col items-center">{tag}<div style={title}>{a.title}</div><div style={body}>{a.body}</div><Details a={a} /></div>
    </div>
  );
}
